import React from 'react';
import Link from "@mui/material/Link";


export default function BasicLink({label, link, openInNewTab, sx = {}}) {

    return(
        <Link sx={{...{
            width: '100%',
            fontSize: '16px',
            padding: '0',
            color: '#125e82',
            fontFamily: 'LarsseitMedium',
            textTransform: 'none',
            ':hover': {
                color: '#125e82',
                textDecoration: 'none',
            },
            ':focus': {
                color: '#125e82',
                textDecoration: 'none',
            },
        }, ...sx}} href={link} target={openInNewTab ? '_blank' : ''} rel="noopener" underline="none">
            {label}
        </Link>
    )
}